import { render, staticRenderFns } from "./lvtong.vue?vue&type=template&id=af1f5edc&scoped=true"
import script from "./lvtong.vue?vue&type=script&lang=js"
export * from "./lvtong.vue?vue&type=script&lang=js"
import style0 from "./lvtong.vue?vue&type=style&index=0&id=af1f5edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1f5edc",
  null
  
)

export default component.exports